import { render, staticRenderFns } from "./DashboardGoals.vue?vue&type=template&id=e18e2aa2"
import script from "./DashboardGoals.vue?vue&type=script&lang=js"
export * from "./DashboardGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports